import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <span className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-book-read-line text-2xl text-primary-400"></i>
                </span>
                <span className="text-xl font-heading font-bold text-background-50">布丁漫画</span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                下拉式看漫画，一气呵成不卡顿。
                <br />
                韩漫、国漫、日漫全集免费阅读，
                <br />
                支持在线追更。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="#footer-categories" className="cursor-pointer">漫画分类</a>
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="#footer-more-categories" className="cursor-pointer">更多分类</a>
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="#footer-about" className="cursor-pointer">关于我们</a>
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    品牌故事
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    用户口碑
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    联系我们
                  </Link>
                </li>
              </ul>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-wechat-line text-sm text-background-300"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-weibo-line text-sm text-background-300"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-bilibili-line text-sm text-background-300"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800/60">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-background-500">
                &copy; 2019-2026 布丁漫画 BudingManhua.com 保留所有权利
              </p>
              <div className="flex items-center gap-6">
                <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">用户协议</a>
                <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">隐私政策</a>
                <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">版权声明</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}